// Update Shopify subscription policy text to reflect current subscription terms on the frontend.
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('p.shopify_subscriptions_app_policy').forEach(function(element) {
      element.textContent = '3-month minimum commitment. Skip or cancel anytime after.';
      element.style.display = 'block';
  });
});






/* 
// Converts subscription radio buttons into a dropdown select element 
// with custom event handling and logging for selected plan values.
*/
document.addEventListener('DOMContentLoaded', function() {
    const subscriptionBlock = document.querySelector('.shopify_subscriptions_app_block');
    if (!subscriptionBlock) return;

    // Hide the entire list of original radio buttons
    const subscriptionRadioList = subscriptionBlock.querySelector('ul.shopify_subscriptions_app_block_label_children');
    if (subscriptionRadioList) {
        subscriptionRadioList.style.display = 'none';

        // Add class to the nearest .shopify_subscriptions_app_block_label parent
        const nearestParentLabel = subscriptionRadioList.closest('.shopify_subscriptions_app_block_label');
        if (nearestParentLabel) {
            nearestParentLabel.classList.add('has-custom-subscribe-wrapper');
        }
    }

    // Create a new <select> element for the dropdown and hide it initially
    const selectElement = document.createElement('select');
    selectElement.classList.add('custom-subscribe-dropdown');
    selectElement.style.display = 'none';

    // Populate the select with options matching the original radio buttons
    subscriptionBlock.querySelectorAll('input[data-radio-type="selling_plan"]').forEach(radio => {
        const option = document.createElement('option');
        option.value = radio.dataset.sellingPlanId;
        option.innerText = radio.nextSibling.textContent.trim();
        if (radio.checked) option.selected = true;
        selectElement.appendChild(option);
    });

    // Create the customRadio button and clone the subscribeLabel
    const customRadio = document.createElement('input');
    customRadio.type = 'radio';
    customRadio.name = 'custom_subscription_option';
    customRadio.classList.add('custom-subscribe-radio');

    const subscribeLabel = subscriptionBlock.querySelector('.shopify_subscriptions_app_block_label .shopify_subscriptions_purchase_option_wrapper > label');
    const clonedSubscribeLabel = subscribeLabel ? subscribeLabel.cloneNode(true) : null;

    if (clonedSubscribeLabel) clonedSubscribeLabel.prepend(customRadio);

    // Wrap clonedSubscribeLabel and selectElement in a new div
    const wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('custom-subscribe-wrapper');
    if (clonedSubscribeLabel) wrapperDiv.appendChild(clonedSubscribeLabel);
    wrapperDiv.appendChild(selectElement);

    // Insert the wrapper div right after the original subscriptionRadioList
    if (subscriptionRadioList) {
        subscriptionRadioList.after(wrapperDiv);
    }

    // Hide the original subscribeLabel
    if (subscribeLabel) subscribeLabel.style.display = 'none';

    let lastSelectedOption = selectElement.value;

    // function logSellingPlanValue() {
    //     const sellingPlanInput = document.querySelector('input.selected-selling-plan-id');
    //     if (sellingPlanInput) console.log("Selling Plan Value:", sellingPlanInput.value);
    // }

    const oneTimePurchaseRadio = subscriptionBlock.querySelector('input[data-radio-type="one_time_purchase"]');
    if (oneTimePurchaseRadio) {
        oneTimePurchaseRadio.addEventListener('change', function() {
            if (oneTimePurchaseRadio.checked) {
                customRadio.checked = false;
                selectElement.style.display = 'none';
                lastSelectedOption = selectElement.value;
                // logSellingPlanValue();
            }
        });
    }

    if (customRadio) {
        customRadio.addEventListener('change', function() {
            if (customRadio.checked) {
                selectElement.style.display = '';
                selectElement.value = lastSelectedOption || selectElement.options[0].value;

                selectElement.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }

    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.target.checked) {
                // logSellingPlanValue();
            }
        });
    });

    subscriptionBlock.querySelectorAll('input[data-radio-type="selling_plan"]').forEach(radio => {
        observer.observe(radio, { attributes: true, attributeFilter: ['checked'] });
    });

    selectElement.addEventListener('change', function() {
        const selectedValue = this.value;

        subscriptionBlock.querySelectorAll('input[data-radio-type="selling_plan"]').forEach(function(radio) {
            if (radio.dataset.sellingPlanId === selectedValue) {
                radio.checked = true;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });

        lastSelectedOption = selectedValue;
        if (customRadio) customRadio.checked = true;
        // logSellingPlanValue();
    });
});



// Expandable "Read more" functionality: displays full content if over 3 lines, with gradient fade and toggle button
// for collection description to the bottom of the page
(function() {
    document.addEventListener("DOMContentLoaded", function() {
        const description = document.querySelector(".at_the_bottom .subcollections-featured-collection__description");

      // Exit early if the element is not found
        if (!description) {
            console.warn("Element '.at_the_bottom .subcollections-featured-collection__description' not found in the DOM.");
            return;
        }

        // Check if content exceeds 3 lines
        if (description.scrollHeight > description.clientHeight) {
            description.classList.add("has-fade"); // Add gradient fade only when necessary

            // Create and style the "Read more" button dynamically
            const readMoreBtn = document.createElement("button");
            readMoreBtn.className = "read-more-btn";
            readMoreBtn.textContent = "Read more";

            // Append button after description
            description.parentNode.appendChild(readMoreBtn);

            // Toggle expanded view on button click
            readMoreBtn.addEventListener("click", function() {
                description.classList.toggle("expanded");
                readMoreBtn.textContent = description.classList.contains("expanded") ? "Show less" : "Read more";
            });

            // Display the "Read more" button if content exceeds restricted height
            readMoreBtn.style.display = "inline";
        }
    });
})();



// open monstercart drawer
document.addEventListener('DOMContentLoaded', () => {
  // console.log('DOM fully loaded and parsed.');

  // Select all buttons with the specific class and `data-quick-buy` attribute
  const buttons = document.querySelectorAll(
    '.productitem--action-trigger.productitem--action-atc[data-quick-buy]'
  );

  // Add event listeners to each button
  buttons.forEach((button, index) => {
    // console.log(`Attaching click event listener to button #${index + 1}`);
    button.addEventListener('click', () => {
      // console.log('Button clicked. Refreshing the cart with Monster Cart API...');
      
      // Use monster_refresh with a callback to ensure the cart is opened only after refresh
      if (window.monster_refresh ) {
        window.monster_refresh(true, () => {
          // console.log('Cart refreshed. Opening the cart drawer...');
          
          if (window.openCart) {
            window.openCart();
          } else {
            // console.warn('openCart function is not available.');
          }
        });
      } else {
        // console.error('Monster Cart API (monster_refresh) is not available.');
      }
    });
  });

  // console.log('Event listeners attached to all buttons.');
});



// for slideshow section subheading
// Dynamically adds a bounce animation to elements containing the arrow "↓" to visually hint at scrolling.

document.addEventListener("DOMContentLoaded", () => {
    // Select all elements with the class "slideshow-slide__subheading"
    const subheadings = document.querySelectorAll(".slideshow-slide__subheading");

    subheadings.forEach((subheading) => {
        // Check if the subheading contains the arrow "↓"
        if (subheading.textContent.includes("↓")) {
            // Add the animation class
            subheading.classList.add("animate-arrow");
        }
    });
});






/*
This script dynamically injects a "Notify Me When Available" button for out-of-stock products
and populates the Klaviyo back-in-stock form with product and variant data using MutationObserver.
It ensures compatibility with Shopify's dynamic product data and Klaviyo's JavaScript-injected forms.
*/

// document.addEventListener('DOMContentLoaded', function () {
//     // Check if ShopifyAnalytics is available
//     if (!window.ShopifyAnalytics || !ShopifyAnalytics.meta || !ShopifyAnalytics.meta.product) {
//         console.error('Shopify product data is not available.');
//         return;
//     }

//     const product = ShopifyAnalytics.meta.product; // Shopify product data
//     const productName = product.title || 'Default Product Name'; // Fallback in case of missing product name

//     console.log('Shopify Product Data:', product);

//     // Get variant data from the <script> tag
//     const variantDataElement = document.getElementById('variant-data');
//     if (!variantDataElement) {
//         console.error('Variant data script tag not found.');
//         return;
//     }

//     const variants = JSON.parse(variantDataElement.textContent);
//     console.log('Variants Data:', variants);

//     // Create the Notify Me button
//     function createNotifyMeButton() {
//         const notifyButton = document.createElement('a');
//         notifyButton.id = 'back-in-stock-form-trigger';
//         notifyButton.className = 'product-form--atc-button button-primary klaviyo-bis-trigger';
//         notifyButton.href = '#';
//         notifyButton.innerText = 'Notify Me When Available';

//         // Attach event listener to open the Klaviyo form popup
//         notifyButton.addEventListener('click', function (e) {
//             e.preventDefault(); // Prevent default link behavior
//             if (window._klOnsite) {
//                 window._klOnsite.push(['openForm', 'XHrw4w']); // Show Klaviyo popup
//             } else {
//                 console.error('Klaviyo onsite form script not loaded.');
//             }
//         });

//         return notifyButton;
//     }

//     const notifyButton = createNotifyMeButton();

//     // Append the button to the DOM but hide it initially
//     const productFormATC = document.querySelector('.product-form--atc');
//     if (productFormATC) {
//         productFormATC.parentNode.insertBefore(notifyButton, productFormATC.nextSibling);
//         notifyButton.style.display = 'none'; // Hide initially
//     } else {
//         console.error('Shopify product form not found.');
//         return;
//     }

//     // Function to check stock status of the selected variant
//     function updateNotifyMeButtonVisibility(selectedVariantId) {
//         const selectedVariant = variants.find(variant => variant.id == selectedVariantId);

//         if (!selectedVariant) {
//             console.error('Selected variant not found in variant data.');
//             notifyButton.style.display = 'none';
//             return;
//         }

//         console.log('Selected Variant Data:', selectedVariant);

//         // Show or hide the button based on inventory status
//         if (selectedVariant.inventoryQuantity <= 0) {
//             notifyButton.style.display = 'inline-block'; // Show button
//         } else {
//             notifyButton.style.display = 'none'; // Hide button
//         }
//     }

//     // Listen for changes to the variant selection
//     const variantSelector = document.querySelector('[name="id"]');
//     if (variantSelector) {
//         // Initial check based on the default selected variant
//         updateNotifyMeButtonVisibility(variantSelector.value);

//         // Update button visibility on variant change
//         variantSelector.addEventListener('change', function () {
//             updateNotifyMeButtonVisibility(this.value);
//         });
//     } else {
//         console.error('Variant selector not found.');
//     }

//     // Observe the DOM for the Klaviyo form being added
//     const observer = new MutationObserver((mutationsList, observer) => {
//         mutationsList.forEach(mutation => {
//             if (mutation.type === 'childList') {
//                 const klaviyoForm = document.querySelector('[data-testid="klaviyo-form-XHrw4w"]');
//                 if (klaviyoForm) {
//                     observer.disconnect(); // Stop observing once the form is found
//                     console.log('Klaviyo form detected.');
//                     populateKlaviyoForm(klaviyoForm);
//                 }
//             }
//         });
//     });

//     // Start observing the body for dynamically injected Klaviyo form
//     observer.observe(document.body, { childList: true, subtree: true });

//     // Function to populate Klaviyo form fields dynamically
//     function populateKlaviyoForm(klaviyoForm) {
//         console.log('Populating Klaviyo form fields...');

//         const selectedVariant = variants.find(variant => variant.id == variantSelector.value);
//         if (!selectedVariant) {
//             console.error('Selected variant not found in variant data for Klaviyo form.');
//             return;
//         }

//         // Replace placeholders dynamically
//         klaviyoForm.innerHTML = klaviyoForm.innerHTML.replace(/%%PRODUCT_NAME%%/g, productName);

//         const populateField = (selector, value) => {
//             const field = klaviyoForm.querySelector(selector);
//             if (field) field.value = value;
//         };

//         populateField('#VariantId_01JHJWECR9FYVR40J85AQP555J', selectedVariant.id);
//         populateField('#VariantName_01JHJWGHMW2ASE334C9K5E6EP5', selectedVariant.title || 'Default Title');
//         populateField('#ProductID_01JHJWBPV2A7HYRNG5870QJASA', productName);
//     }
// });



/**
 * This script replaces the Klaviyo message input field with a textarea on the 
 * "/pages/find-a-contractor" page. The textarea syncs its value to the hidden 
 * input field in real-time to ensure proper form submission. The script uses 
 * MutationObserver to detect when the form loads dynamically.
 */

(function () {
    // Run only on the specific page
    if (window.location.pathname !== "/pages/find-a-contractor") return;

    function observeFormAndReplaceMessageField() {
        const observer = new MutationObserver(() => {
            const messageInput = document.getElementById("Message_01JMFHXR1Y7WA9AY2M7SA1YWMR");

            if (messageInput) {
                observer.disconnect(); // Stop observing once found

                // Hide the original input field
                messageInput.style.display = "none";

                // Create a new textarea
                const textarea = document.createElement("textarea");
                textarea.placeholder = "Message";
                textarea.classList.add("custom-message-textarea"); // Add your custom class for styling
                textarea.rows = 5; // Adjust the number of visible lines

                // Insert the textarea before the original input field
                messageInput.parentNode.insertBefore(textarea, messageInput);

                // Sync textarea value to hidden input in real-time
                textarea.addEventListener("input", () => {
                    messageInput.value = textarea.value;
                    messageInput.dispatchEvent(new Event('input', { bubbles: true }));
                    messageInput.dispatchEvent(new Event('change', { bubbles: true }));
                });
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    // Initialize observer when script runs
    observeFormAndReplaceMessageField();
})();



// Open all links containing aquascapeuniversity.com or aquascapeinc.com in a new tab
document.addEventListener("DOMContentLoaded", function () {
  const domains = ["aquascapeuniversity.com", "aquascapeinc.com"];

  document.querySelectorAll("a[href]").forEach((link) => {
    const href = link.getAttribute("href");
    if (
      domains.some((domain) => href.includes(domain)) &&
      link.getAttribute("target") !== "_blank"
    ) {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    }
  });
});





/**                                                                                                                                 * PhotoSwipe Image Popup
   * Usage: Add data-image-popup to any link or image                                                                                 *                                                              
   * For links with custom image:
   * <a href="#" data-image-popup data-image-src="image.jpg" data-image-w="1200" data-image-h="800">Click me</a>
   *
   * For links that open the href as image:
   * <a href="image.jpg" data-image-popup>Click me</a>
   *
   * For images wrapped in links:
   * <a href="full-image.jpg" data-image-popup><img src="thumb.jpg" alt="..."></a>
   */

    // Usage examples:

    //   <!-- Link with custom image -->
    //   <a href="#" data-image-popup 
    //   data-image-src="https://cdn.shopify.com/s/files/1/0710/7782/2767/files/wetland-filter-pond-sizing.webp" data-image-w="1200" 
    //   data-image-h="800">
    //     Click to view image
    //   </a>

    //   <!-- Simple link (uses href as image source) -->
    //   <a href="https://cdn.shopify.com/s/files/1/0710/7782/2767/files/wetland-filter-pond-sizing.webp" data-image-popup>
    //     View larger
    //   </a>

    //   <!-- Image wrapped in link (auto-detects dimensions from img) -->
    //   <a href="https://cdn.shopify.com/s/files/.../full-image.webp" data-image-popup>
    //     <img src="https://cdn.shopify.com/s/files/.../thumb-image.webp" alt="Wetland filter">
    //   </a>

  document.querySelectorAll('[data-image-popup]').forEach(element => {
    element.addEventListener('click', (e) => {
      e.preventDefault();

      const pswpElement = document.querySelector('[data-photoswipe]');
      if (!pswpElement) return;

      let src;

      // Check if image data is in data attributes
      if (element.dataset.imageSrc) {
        src = element.dataset.imageSrc;
      } else if (element.tagName === 'A' && element.href) {
        src = element.href;
      }

      const options = {
        index: 0,
        barsSize: { top: 0, bottom: 0 },
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: false,
        arrowEl: false,
        preloaderEl: false,
        history: false,
        closeOnScroll: false,
        showHideOpacity: true,
        clickToCloseNonZoomable: false,
        tapToClose: false,
        pinchToClose: true,
        closeOnVerticalDrag: true
      };

      // Preload image to get real dimensions
      const imgLoader = new Image();
      imgLoader.onload = function() {
        const items = [{
          src: src,
          w: this.naturalWidth,
          h: this.naturalHeight
        }];

        const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

        // Manually handle close button
        const closeBtn = pswpElement.querySelector('.pswp__button--close');
        const closeHandler = () => gallery.close();

        closeBtn.addEventListener('click', closeHandler);
        closeBtn.addEventListener('touchstart', closeHandler);

        gallery.listen('destroy', () => {
          closeBtn.removeEventListener('click', closeHandler);
          closeBtn.removeEventListener('touchstart', closeHandler);
        });

        gallery.init();
      };

      imgLoader.src = src;
    });
  });


  /**
   * PhotoSwipe multi-item gallery for DIY Project cards.
   * Delegated so it survives Shopify section-customizer re-renders.
   * Handles a mix of images and video-html slides.
   */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-diy-gallery]');
    if (!trigger) return;
    e.preventDefault();

    var pswpEl = document.querySelector('[data-photoswipe]');
    if (!pswpEl || typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') return;

    var items;
    try { items = JSON.parse(trigger.getAttribute('data-diy-gallery')); }
    catch (err) { return; }
    if (!items || !items.length) return;

    var options = {
      index: 0,
      history: false,
      shareEl: false,
      fullscreenEl: true,
      zoomEl: true,
      arrowEl: true,
      counterEl: true,
      closeOnScroll: false,
      bgOpacity: 0.9,
      showHideOpacity: true
      // getThumbBoundsFn intentionally omitted: card images are 4:3 cover-cropped
      // but source images have varying aspect ratios, so a zoom-to-thumb animation
      // looks jarring. Fade in/out via showHideOpacity instead.
    };

    pswpEl.classList.add('pswp--diy-gallery');
    var gallery = new PhotoSwipe(pswpEl, PhotoSwipeUI_Default, items, options);

    // Toggle is-paused on the wrapper when video state changes, and wire
    // the custom play overlay button to start playback.
    var handleVideoEvent = function (e) {
      var v = e.target;
      if (!v || v.tagName !== 'VIDEO') return;
      var wrap = v.closest('.pswp-video');
      if (!wrap) return;
      if (e.type === 'play' || e.type === 'playing') wrap.classList.remove('is-paused');
      else wrap.classList.add('is-paused');
    };
    pswpEl.addEventListener('play', handleVideoEvent, true);
    pswpEl.addEventListener('playing', handleVideoEvent, true);
    pswpEl.addEventListener('pause', handleVideoEvent, true);
    pswpEl.addEventListener('ended', handleVideoEvent, true);

    var handlePlayClick = function (e) {
      var btn = e.target.closest('.pswp-video__play');
      if (!btn) return;
      var wrap = btn.closest('.pswp-video');
      var v = wrap && wrap.querySelector('video');
      if (v) { try { v.play(); } catch (_) {} }
    };
    pswpEl.addEventListener('click', handlePlayClick);

    var pauseVideos = function () {
      pswpEl.querySelectorAll('video').forEach(function (v) {
        try { v.pause(); } catch (_) {}
      });
    };

    gallery.listen('beforeChange', pauseVideos);
    gallery.listen('close', pauseVideos);

    var closeBtn = pswpEl.querySelector('.pswp__button--close');
    var closeHandler = function () { gallery.close(); };
    if (closeBtn) {
      closeBtn.addEventListener('click', closeHandler);
      closeBtn.addEventListener('touchstart', closeHandler);
    }
    gallery.listen('destroy', function () {
      pswpEl.classList.remove('pswp--diy-gallery');
      pswpEl.removeEventListener('play', handleVideoEvent, true);
      pswpEl.removeEventListener('playing', handleVideoEvent, true);
      pswpEl.removeEventListener('pause', handleVideoEvent, true);
      pswpEl.removeEventListener('ended', handleVideoEvent, true);
      pswpEl.removeEventListener('click', handlePlayClick);
      if (closeBtn) {
        closeBtn.removeEventListener('click', closeHandler);
        closeBtn.removeEventListener('touchstart', closeHandler);
      }
    });

    gallery.init();
  });



// Refresh YouTube iframes once when their hidden tab becomes visible so the preview renders at the correct size.
document.querySelectorAll('.tab-radio').forEach(function (tab) {
  tab.addEventListener('change', function () {
    var panel = tab.nextElementSibling.nextElementSibling;
    if (!panel) return;

    panel.querySelectorAll('iframe[src*="youtube.com/embed"]').forEach(function (iframe) {
      if (iframe.dataset.refreshed) return;

      iframe.src = iframe.src;
      iframe.dataset.refreshed = 'true';
    });
  });
});




